<template>
    <div class="kub-usadba-theme theme-wrapper">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
}
</script>
